const initialState = {
    tagSelectedPayload: null,
    pageNo:0,
    totalCount:0,
    data:[],
    isLoading:false,
    searchQuery:'',
    isBack:false,
    data2:[]
}

const keytagDataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case 'getkeyTagPayload':
    state = {...state, pageNo:0};
    state = {...state, totalCount:0};
    state = {...state, data:[], data2:[]};
    state = { ...state, isLoading:true };
    state = { ...state, searchQuery:'' };
    state = { ...state, tagSelectedPayload:payload, isBack:payload===null?false:true };
    return state;
  case 'getKeyTagsData':
    let newData = [];
    if(state.pageNo === 0){
      newData = payload.data;
    }else{
      newData = state.data.concat(payload.data);
    }
    state = {...state, totalCount:payload.count, isLoading:false}
    state = {...state, data: newData, data2:payload.data};
    state = {...state, isLoading:false}
    return state;
  case 'KeyTagsDataIsLoading':
    state ={...state, isLoading:payload};
    return state;
  case 'KeyTagsDataSearchQuery':
    state ={...state, pageNo:0};
    state ={...state, searchQuery:payload};
    return state;
  case 'KeyTagsDataPageNoUpdate':
    state ={...state, pageNo:payload};
    return state;
  case 'KeyTagsDataSourceUpdate':
    let obj = state.tagSelectedPayload;
    obj.source = payload;
    state = {...state, pageNo:0};
    state = {...state, totalCount:0};
    state = {...state, data:[], data2:[]};
    state = { ...state, isLoading:true };
    state = { ...state, searchQuery:'' };
    state = { ...state, tagSelectedPayload:obj };
    return state;
  case 'updateKeyTagData':
    state = {...state, data:payload, data2:payload};
    return state;
  default:
    return state
  }
}

export default keytagDataReducer;
